import bem from 'utils/bem';

export const block = bem('adjustment-needed-modal');
